import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AccSettingsPrjPageUI from './AccSettingsPrjPageUI.js'

class AccSettingsPrjPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      subscription: null,
      accountName: null,
      paymentMethodList: [],
      messageList: null,
      errorList: null,
    }
  }

  render() {
    return (
      <AccSettingsPrjPageUI
        context={this.props.context}
        subscription={this.state.subscription}
        accountName={this.state.accountName}
        paymentMethodList={this.state.paymentMethodList}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        //
        onNameUpdated={this.onNameUpdated}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getSubscription(context)
    this.getAccountName(context)
    this.getMessages(context)
    if (context.permissions.includes('acc_billing'))
      this.getPaymentMethods(context)
  }

  getSubscription(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/subscription`,
      cacheKey: CacheKeys.Subscription(context.session.accountId),
      callback: this.getSubscriptionCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSubscriptionCallback = (response) => {
    this.setState({errorList: response.errorList, subscription : response.subscription})
  }

  getPaymentMethods(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/paymentMethods`,
      cacheKey: CacheKeys.PaymentMethods(context.session.accountId),
      callback: this.getPaymentMethodsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPaymentMethodsCallback = (response) => {
    this.setState({paymentMethodList : response.paymentMethodList})
  }

  getAccountName(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/name`,
      cacheKey: CacheKeys.AccountName(context.session.accountId),
      callback: this.getAccountNameCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountNameCallback = (response) => {
    this.setState({accountName : response.accountName})
  }

  onNameUpdated = (accountName) => {
    let context = this.props.context
    this.setState({accountName: accountName})
    CacheManager.removeObject(CacheKeys.AccountName(context.session.accountId))
  }

  getMessages(context) {
    let arr = [
      'c_account_settings',
      'c_account_name',
      'c_customers',
      'c_product_items',
      'c_subscription',
      'c_credit_card',
      'c_update',
      'c_cancel'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_st_prj', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default AccSettingsPrjPageSF
